<template>
    <div>
        <form style="margin: 20px" @submit.prevent="sendRequest">
            <div class="form-group">
                <label>Lista de origen</label>
                <multiselect
                    v-model="lista_origen_selected"
                    :options="listasArray"
                    placeholder="Selecciona una opción"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    @select="lista_origen_id = $event.value"
                />
            </div>

            <div class="form-group">
                <label>Lista de abonados activa</label>
                <multiselect
                    :value="{value: user.lista.id, label: user.lista.id + ' - ' + user.lista.nombre}"
                    :options="listasArray"
                    placeholder="Lista de abonados activa"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    disabled
                />
            </div>

            <div class="form-group">
                <label>Solo activos</label>
                <multiselect
                    v-model="solo_activos_selected"
                    :options="[{value: true, label: 'Sí'}, {value: false, label: 'No'}]"
                    placeholder="Selecciona una opción"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    @select="solo_activos = $event.value"
                />
            </div>

            <button type="submit" class="btn btn-primary">
                Clonar lista
            </button>
        </form>
        <h3>{{respuesta}}</h3>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import store from '@/store';
    import Multiselect from 'vue-multiselect';
    import { config } from '@/config.js';

    const lista_origen_id = ref(null);
    const lista_origen_selected = ref(null);
    const solo_activos = ref(true);
    const solo_activos_selected = ref({ value: true, label: 'Sí' });
    const respuesta = ref('');

    const user = computed(() => store.getters.getUser);

    const listas = computed(() => {
        const l = {};
        for (let i in user.value.listas) {
            l[user.value.listas[i].id] = user.value.listas[i].id + ' - ' + user.value.listas[i].nombre;
        }
        return l;
    });

    const listasArray = computed(() => {
        return user.value.listas.map(lista => ({
            value: lista.id,
            label: lista.id + ' - ' + lista.nombre
        }));
    });

    const listaActivaSeleccionada = computed(() => ({
        value: user.value.lista.id,
        label: user.value.lista.id + ' - ' + user.value.lista.nombre
    }));

    const onSelectListaOrigen = event => {
        lista_origen_id.value = event.value;
    };

    const onSelectSoloActivos = event => {
        solo_activos.value = event.value;
    };

    const sendRequest = async() => {
        respuesta.value = 'Espera...';

        const url = `${config.API_BASE}/listas-abonados/${user.value.lista.id}/import/lista/${lista_origen_id.value}?api_key=${localStorage.getItem('token')}`;

        const formdata = new FormData();
        formdata.append('solo_activos', solo_activos.value);

        const requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        try {
            const response = await fetch(url, requestOptions);
            const result = await response.json();

            if (result.error) {
                respuesta.value = `Error: ${result.message || result.error}`;
            } else {
                respuesta.value = result.message || JSON.stringify(result);
            }
        } catch (error) {
            respuesta.value = `Error: ${error.message}`;
        }
    };
</script>
